<div class="w-full flex flex-col gap-6">
  <div class="w-full flex justify-between items-center pl-1">
    <div class="justify-start text-surface-800 text-2xl font-medium font-['Inter']">Review Template</div>
    <div class="flex gap-4">
      <p-button data-testid="template-save"
                label="Save Template"
                [disabled]="!titleValid() || store.isSavingData()"
                (onClick)="saveTemplate()">
        <svg width="14" height="16" viewBox="0 0 14 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M0 2.475C0 1.11221 1.11221 0 2.475 0H9.225C9.40402 0 9.57571 0.0711159 9.7023 0.197703L13.7523 4.2477C13.8789 4.37429 13.95 4.54598 13.95 4.725V13.275C13.95 14.6378 12.8378 15.75 11.475 15.75H2.475C1.11221 15.75 0 14.6378 0 13.275V2.475ZM2.475 1.35C1.85779 1.35 1.35 1.85779 1.35 2.475V13.275C1.35 13.8922 1.85779 14.4 2.475 14.4H2.7V9.225C2.7 8.60921 3.20921 8.1 3.825 8.1H10.125C10.7585 8.1 11.25 8.61802 11.25 9.225V14.4H11.475C12.0922 14.4 12.6 13.8922 12.6 13.275V5.00459L8.94541 1.35H8.54999V3.78001C8.54999 4.39827 8.05585 4.95 7.39799 4.95H3.84299C3.18513 4.95 2.69099 4.39827 2.69099 3.78001V1.35H2.475ZM4.04099 1.35V3.6H7.19999V1.35H4.04099ZM9.9 14.4H4.05V9.45H9.9V14.4Z" fill-rule="evenodd" clip-rule="evenodd" fill="white"/>
        </svg>
      </p-button>
      <p-button data-testid="template-delete"
                label="Delete Template"
                severity="danger"
                [disabled]="store.isSavingData()"
                (onClick)="deleteTemplate()">
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M4.446 2.03285C4.446 1.75828 4.75585 1.34923 5.373 1.34923H10.377C10.9973 1.34923 11.304 1.7519 11.304 2.03285V3.39108C11.304 3.45011 11.3116 3.50736 11.3258 3.56193H4.42417C4.43842 3.50736 4.446 3.45011 4.446 3.39108V2.03285ZM3.11784 3.56193C3.10359 3.50736 3.096 3.45011 3.096 3.39108V2.03285C3.096 0.814271 4.22615 0 5.373 0H10.377C11.5207 0 12.654 0.802652 12.654 2.03285V3.39108C12.654 3.45011 12.6464 3.50736 12.6322 3.56193H15.075C15.4478 3.56193 15.75 3.86396 15.75 4.23654C15.75 4.60912 15.4478 4.91116 15.075 4.91116H14.148V13.7172C14.148 14.9357 13.0178 15.75 11.871 15.75H3.87C2.72626 15.75 1.593 14.9473 1.593 13.7172V4.91116H0.675C0.302208 4.91116 0 4.60912 0 4.23654C0 3.86396 0.302208 3.56193 0.675 3.56193H2.277H3.11784ZM2.943 4.91116V13.7172C2.943 13.9981 3.24975 14.4008 3.87 14.4008H11.871C12.4882 14.4008 12.798 13.9917 12.798 13.7172V4.91116H2.943ZM6.273 6.95301C6.64579 6.95301 6.948 7.25504 6.948 7.62762V11.6933C6.948 12.0659 6.64579 12.3679 6.273 12.3679C5.90021 12.3679 5.598 12.0659 5.598 11.6933V7.62762C5.598 7.25504 5.90021 6.95301 6.273 6.95301ZM10.152 7.62762C10.152 7.25504 9.84979 6.95301 9.477 6.95301C9.10421 6.95301 8.802 7.25504 8.802 7.62762V11.6933C8.802 12.0659 9.10421 12.3679 9.477 12.3679C9.84979 12.3679 10.152 12.0659 10.152 11.6933V7.62762Z" fill-rule="evenodd" clip-rule="evenodd" fill="white"/>
        </svg>
      </p-button>
    </div>
  </div>

  <p-card styleClass="template-tint" data-testid="template-title-card">
    <div class="flex gap-2">
      <div class="flex flex-col w-64 bg-surface-0 p-6 gap-2 rounded-l-2xl shadow-[0px_1px_2px_-1px_rgba(0,0,0,0.10),0px_1px_3px_0px_rgba(0,0,0,0.10)]">
        <div class="text-surface-800 text-lg font-medium font-['Inter']">Template Title</div>
        <div class="text-surface-600 text-sm font-light font-['Inter']">Give your template a meaningful title.</div>
      </div>
      <div class="flex-1 flex flex-col gap-2 bg-surface-0 p-6 rounded-r-2xl shadow-[0px_1px_2px_-1px_rgba(0,0,0,0.10),0px_1px_3px_0px_rgba(0,0,0,0.10)]">
        <label for="template-title"><span class="text-text-color text-sm font-normal font-['Inter'] leading-5">Title</span><span class="text-red-700 text-sm font-normal font-['Inter'] leading-5">*</span></label>
        <input id="template-title"
               type="text"
               pInputText
               pSize="small"
               class="lg:w-1/2 w-full"
               maxlength="256"
               data-testid="template-title"
               [ngModel]="title()"
               (ngModelChange)="title.set($event)"
               [invalid]="!titleValid()"
        />
        @if (!titleValid()) {
          <small class="text-red-700 text-xs font-['Inter']">A title is required.</small>
        }
      </div>
    </div>
  </p-card>

  <p-card>
    <div class="flex flex-col gap-4">
      <!-- Step 1 -->
      <div class="flex gap-2">
        <div class="flex flex-col w-64 bg-surface-0 p-6 gap-2 rounded-l-2xl shadow-[0px_1px_2px_-1px_rgba(0,0,0,0.10),0px_1px_3px_0px_rgba(0,0,0,0.10)]">
          <div class="text-surface-800 text-base font-normal font-['Inter']">Step 1</div>
          <div class="text-surface-800 text-lg font-medium font-['Inter']">Who's Travelling</div>
        </div>
        <div class="flex-1 flex gap-4 bg-surface-0 p-6 rounded-r-2xl shadow-[0px_1px_2px_-1px_rgba(0,0,0,0.10),0px_1px_3px_0px_rgba(0,0,0,0.10)]">
          <div class="flex-1 min-w-0">
            <create-template-travellers [isReadOnly]="true"></create-template-travellers>
          </div>
          <div>
            <p-button size="small" label="Edit" icon="fa-regular fa-pen" iconPos="right"
                      data-testid="template-edit-travellers"
                      (onClick)="openEditModal(CreateTaStepType.TRAVELLERS)"></p-button>
          </div>
        </div>
      </div>

      <!-- Step 2 -->
      <div class="flex gap-2">
        <div class="flex flex-col w-64 bg-surface-0 p-6 gap-2 rounded-l-2xl shadow-[0px_1px_2px_-1px_rgba(0,0,0,0.10),0px_1px_3px_0px_rgba(0,0,0,0.10)]">
          <div class="text-surface-800 text-base font-normal font-['Inter']">Step 2</div>
          <div class="text-surface-800 text-lg font-medium font-['Inter']">Travel Details</div>
          <div class="text-surface-800 text-sm font-medium font-['Inter'] pt-2">Approvers</div>
          <div class="text-surface-600 text-sm font-light font-['Inter']">The Primary and Secondary Approvers will be set/selected when creating a TA based on this template.</div>
        </div>
        <div class="flex-1 flex gap-4 bg-surface-0 p-6 rounded-r-2xl shadow-[0px_1px_2px_-1px_rgba(0,0,0,0.10),0px_1px_3px_0px_rgba(0,0,0,0.10)]">
          <div class="flex-1 min-w-0">
            <create-template-details [isReadOnly]="true"></create-template-details>
          </div>
          <div>
            <p-button size="small" label="Edit" icon="fa-regular fa-pen" iconPos="right"
                      data-testid="template-edit-details"
                      (onClick)="openEditModal(CreateTaStepType.DETAILS)"></p-button>
          </div>
        </div>
      </div>

      <!-- Step 3 -->
      <div class="flex gap-2">
        <div class="flex flex-col w-64 bg-surface-0 p-6 gap-2 rounded-l-2xl shadow-[0px_1px_2px_-1px_rgba(0,0,0,0.10),0px_1px_3px_0px_rgba(0,0,0,0.10)]">
          <div class="text-surface-800 text-base font-normal font-['Inter']">Step 3</div>
          <div class="text-surface-800 text-lg font-medium font-['Inter']">Itinerary</div>
        </div>
        <div class="flex-1 flex gap-4 bg-surface-0 p-6 rounded-r-2xl shadow-[0px_1px_2px_-1px_rgba(0,0,0,0.10),0px_1px_3px_0px_rgba(0,0,0,0.10)]">
          <div class="flex-1 min-w-0">
            <create-template-itinerary [isReadOnly]="true"></create-template-itinerary>
          </div>
          <div>
            <p-button size="small" label="Edit" icon="fa-regular fa-pen" iconPos="right"
                      data-testid="template-edit-itinerary"
                      (onClick)="openEditModal(CreateTaStepType.ITINERARY)"></p-button>
          </div>
        </div>
      </div>
    </div>
  </p-card>
</div>
